/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/display-name */
import SuspenseLoader from 'components/SuspenseLoader';
import { Suspense } from 'react';

const Loader =
  (Component: any) =>
  (props: any): JSX.Element => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

export default Loader;
